<template>
  <div v-if="appOpening" class="app-opening-overlay">
    <div class="payment-waiting">
      <div class="payment-waiting__ring" role="status" aria-label="Chargement"></div>
      <!-- <p class="payment-waiting__text">Ouverture de l'application Izy…</p> -->
      <div class="payment-waiting__dots" aria-hidden="true">
        <span></span><span></span><span></span>
      </div>
    </div>
  </div>

  <div class="row mx-auto mt-1" style="">
    <div class="col-12 col-md-8 col-lg-6 col-xl-7 col-xxl-6 col-xxxl-4">
      <div v-if="showGuichet" class="card mb-25 border-0 rounded-0 bg-white authentication-card">
        <div class="card-body letter-spacing row">
          <h4 class="text-black fw-bold mb-0 text-center col-12 d-flex align-items-center justify-content-center gap-2">
            Payez avec
            <img src="/img/izypay.png" alt="IzyPay" class="izypay-logo" />
          </h4>
          <div class="col-12">
            <div v-if="errors !== ''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId }}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors }}</h6>
            </div>
            <div v-if="success !== ''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success }}</h6>
            </div>
          </div>
          <div class="col-12">
            <form @submit.prevent="initTransaction">

              <div class="row" v-if="step1 == 1 && (!status || status == 'PENDING')">
                <div class="form-group col-12 col-md-6">
                  <label class="d-block text-black fw-semibold mb-5">
                    Téléphone
                  </label>
                  <input type="tel" class="form-control shadow-none rounded-0 text-black field w-100" placeholder="0708204050"
                    v-model="phone" id="phone" @keyup="handlePhone($event.target.value, $event.target)"
                    @focus="initOperator($event.target.value, $event.target)"
                    @blur="handlePhone($event.target.value, $event.target)" />
                </div>
                <div class="form-group col-12 col-md-6">
                  <label class="d-block text-black fw-semibold mb-5">Montant</label>
                  <input type="number" class="form-control shadow-none rounded-0 text-black field w-100"
                    placeholder="e.g. 5 000" v-model="amount"
                    @keyup="validate_phone_number($event.target.value, $event.target)"
                    :class="{ 'is-invalid': errorsBis['amount'] }" v-if="amountInit == 0" required />
                  <input type="number" class="form-control shadow-none rounded-0 text-black field w-100"
                    placeholder="e.g. 5 000" v-model="amount"
                    @keyup="validate_phone_number($event.target.value, $event.target)" v-if="amountInit > 0" disabled />
                </div>
              </div>

              <div class="form-group mt-10 mb-10 mb-sm-10 mb-md-25" v-if="step1 == 1">
                <div class="col-md-12" v-if="environment == 'PROD'">
                </div>
              </div>

              <div class="row">
                <div class="col-12">

                  <!-- Zone opérateurs : chargement / liste -->
                  <div v-if="step1 == 1" class="mb-15 mb-md-20">
                    <div v-if="operatorsLoading" class="text-center operators-loading">
                      <div class="spinner-grow text-warning" style="width: 2rem; height: 2rem;" role="status">
                        <span class="visually-hidden">Chargement...</span>
                      </div>
                      <p class="operators-loading__text">Chargement des opérateurs...</p>
                    </div>
                    <div v-else
                      class="text-center form-check form-check-primary mb-0 fs-md-15 fs-lg-16 mr-0 text-muted lh-1 operators-list d-flex flex-row align-items-center justify-content-center">
                      <img v-for="operator in operators" :key="operator.id" :src="operatorImg(operator.mnoName)"
                        class="operator-logo" width="50" height="50" @click="handleOperatorChange(operator.mnoName)" />
                    </div>
                  </div>

                  <button v-if="step1 == 1 && (!status || status == 'PENDING')" @click="next"
                    :disabled="!isStep1Valid"
                    class="w-100 default-btn transition fw-medium text-white rounded-1 d-block border border-warning btn-payer d-flex align-items-center justify-content-center gap-2 py-0 px-5"
                    style="background-color: #fff;border-color:#EB9355;border-width:1px;border-style: solid; height:55px;">
                    <div v-if="selectedOperator">
                      <img v-if="selectedOperator == OTP_OPERATOR" :src="orange" class="operator-img" />
                      <img v-if="selectedOperator == MTN_OPERATOR" :src="mtn" class="operator-img" />
                      <img v-if="selectedOperator == MOOV_OPERATOR" :src="moov" class="operator-img" />
                      <img v-if="selectedOperator == WAVE_OPERATOR" :src="wave" class="operator-img" />
                    </div>
                    <div v-else class="operator-img_div">
                    </div>
                    <span style="color:#EB9355" class="fw-medium">Payer</span>
                  </button>

                  <!-- step 2 -->
                  <div v-if="step2 == 1 && selectedOperator == OTP_OPERATOR" class="form-group mb-15 mb-sm-20 mb-md-25">
                    <h2>Confirmation du paiement</h2>
                  </div>
                  <div v-if="step2 == 1 && selectedOperator == OTP_OPERATOR"
                    class="row line-numbers bg-gray pt-0 pb-0 ps-25 pe-25 mb-0">
                    Suivez les étapes suivantes pour obtenir le code d’autorisation.

                    1. Pour générer un code temporaire, ouvrez l’appli Orange Money Afrique et cliquez sur Mon Compte,
                    ou composez le #144*82# et lancez l’appel
                    2. Tapez votre code secret et validez
                    3. Veuillez copier et coller le code reçu par SMS dans le champ ci-dessous.
                  </div>
                  <div v-if="step2 == 1 && selectedOperator !== OTP_OPERATOR"
                    class="form-group mb-15 mb-sm-20 mb-md-25">
                    <h2>Vérification du paiement</h2>
                    <a href="https://pay.wave.com/" target="_blank" style="visibility: hidden;" id="paymentlink"
                      rel="noopener">payment</a>
                  </div>
                  <div v-if="step2 == 1 && selectedOperator !== OTP_OPERATOR"
                    class="row line-numbers bg-gray pt-1 pb-0 ps-25 pe-25 mb-0">
                    <span v-if="selectedOperator == MTN_OPERATOR">Veuillez saisir votre code secret MTN Money pour
                      confirmer le paiement.</span>
                    <span v-if="selectedOperator == MOOV_OPERATOR">Veuillez saisir votre code secret FLOOZ pour
                      confirmer
                      le paiement.</span>
                    <span v-if="selectedOperator == WAVE_OPERATOR">Vous serez redirigé dans quelques instants vers la
                      page
                      affichant le qrcode à scanner pour finaliser votre opération. si c'est pas le cas, veuillez cliquer sur le bouton "Ouvrir la page de paiement Wave" ci-dessous.</span>
                  </div>
                  <div v-if="step2 == 1 && selectedOperator !== OTP_OPERATOR"
                    class="payment-waiting form-group mb-15 mb-sm-20 mb-md-25">
                    <div class="payment-waiting__ring" role="status" aria-label="Chargement"></div>
                    <p class="payment-waiting__text">Vérification du paiement en cours</p>
                    <div class="payment-waiting__dots" aria-hidden="true">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <div class="form-group mt-10  mb-10 mb-sm-10 mb-md-25"
                    v-if="step2 == 1 && selectedOperator == OTP_OPERATOR">
                    <label class="d-block text-black fw-semibold mb-5">
                      Saisir le code reçu par SMS
                    </label>
                    <input id="otp" type="text" class="form-control shadow-none rounded-0 text-black field"
                      placeholder="**************" v-model="formValues.otp" @blur="validate('otp')"
                      @keyup="validate_phone_number($event.target.value, $event.target, 4)"
                      :class="{ 'is-invalid': errorsBis['otp'] }" />
                    <span class="invalid-feedback">{{ errorsBis['otp'] }}</span>
                  </div>

                  <div class="row justify-content-center g-2"
                    v-if="step2 == 1 && !(selectedOperator == WAVE_OPERATOR && showWavePaymentButton)">
                    <div class="col-6">
                      <button @click="goback"
                        class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100 border border-warning btn-payer"
                        style="background-color: #fff;border-color:#EB9355;border-width:1px;border-style: solid;">

                        <i class="flaticon-chevron-1 mt-2" style="color:#EB9355;"></i>
                        <span class="align-baseline" style="color:#EB9355">Retour</span>
                      </button>
                    </div>
                    <div class="col-6">
                      <button
                        class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100 btn-payer"
                        type="submit" style="background-color: #EB9355;" :disabled="!btnLoad">
                        <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status"
                          aria-hidden="true"></span>
                        Payer
                      </button>
                    </div>
                  </div>
                  <div v-if="step2 == 1 && selectedOperator == WAVE_OPERATOR && showWavePaymentButton"
                    class="mt-2">
                    <button type="button" @click="openWavePayment"
                      class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100 btn-payer"
                      style="background-color: #EB9355;">
                      Ouvrir la page de paiement Wave
                    </button>
                  </div>
                  <!-- step 3 -->
                  <div v-if="status && status == 'SUCCEEDED'" class="form-group mb-15 mb-sm-20 mb-md-25">
                    <h2 class="text-center"><i class="flaticon-secure-shield" style="color:green;"></i></h2>
                    <h3 class="text-center">Votre paiement a été approuvé</h3>
                  </div>
                  <div v-if="status && status == 'FAILED'" class="form-group mb-15 mb-sm-20 mb-md-25">
                    <h2 class="text-center"><i class="flaticon-cancel" style="color:red;"></i></h2>
                    <h2 class="text-center">Votre paiement a échoué</h2>
                  </div>
                  <div v-if="(status && (status == 'PROCESSING' || status == 'PENDING')) && step3 == 1" class="form-group mb-15 mb-sm-20 mb-md-25">
                    <h2 class="text-center"><i class="flaticon-compare" style="color:blue;"></i></h2>
                    <h2 class="text-center">Votre paiement est en cours</h2>
                  </div>
                  <div v-if="status && status != 'PENDING' && btnLoad == true"
                    class="row line-numbers bg-gray pt-0 pb-0 ps-25 pe-25 mb-0">
                    <p><span class="text-black fw-bold">Opérateur : </span><span>{{ selectedOperator }}</span></p>
                    <p><span class="text-black fw-bold">ID Transaction : </span><span>{{ checkoutId }}</span></p>
                    <p><span class="text-black fw-bold">Date Paiement : </span><span>{{ formatDateFr(new Date())
                    }}</span></p>

                  </div>
                  <div v-if="(status && status != 'PENDING') && step3 == 1" class="form-group mb-15 mb-sm-20 mb-md-25">
                    <button @click="download_receipt"
                      class="default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100 border border-warning"
                      style="background-color: #fff;border-color:#EB9355;border-width:1px;border-style: solid;">

                      <span class="align-baseline" style="color:#EB9355">Télécharger le reçu</span>
                    </button>
                  </div>
                  <div ref="PDFReceipt" v-if="status && status != 'PENDING'" id="receipt"
                    class="form-group mb-15 mb-sm-20 mb-md-25 PDFReceipt d-none">
                    <div id="header_receipt">
                      <h2 style="padding:2% 5% 2% 5%;color: #fff;">
                        <span>
                          <img src="../../../assets/images/i-money1.jpg" alt="logo-icon" style="max-width:10%;" />
                          <span class="logo_text">IZYPAY</span>
                        </span>
                        <span id="header_text">
                          REÇU DE TRANSACTION
                        </span>
                      </h2>
                    </div>
                    <div id="body_receipt">
                      <div id="arrow-top-section">
                        <span id="arrow-top-left" class="section_content"><img
                            src="../../../assets/images/arrowtopleft.svg" alt="logo-icon"
                            style="min-width:3%;" /></span>
                        <span id="arrow-top-right" class="section_content"><img
                            src="../../../assets/images/arrowtopright.svg" alt="logo-icon"
                            style="min-width:3%;" /></span>
                      </div>
                      <div id="body_first_section">
                        <p v-if="name != ''"><span class="section_label">BENEFICIAIRE</span>&nbsp;:&nbsp;<span
                            class="section_content">{{ name }}</span></p>
                        <p><span class="section_label">OPERATEUR</span>&nbsp;:&nbsp;<span class="section_content">{{
                          selectedOperator }}</span></p>
                        <p><span class="section_label">TELEPHONE</span>&nbsp;:&nbsp;<span class="section_content">{{
                          phone }}</span></p>
                        <p><span class="section_label">DATE</span>&nbsp;:&nbsp;<span class="section_content">{{
                          formatDateFr(new Date()) }}</span></p>
                        <p style="margin-top: 10%;"><span class="section_label">CODE DE TRANSACTION</span><span
                            class="section_content_other">{{ checkoutId }}</span></p>
                      </div>
                      <div id="body_second_section">
                        <p><span class="section_label">MONTANT...................................... </span><span
                            class="section_content_other1">{{ amount }} F</span></p>
                        <p v-if="status === 'FAILED'"><span
                            class="section_label">STATUT........................................... </span><span
                            class="section_content_other1">ECHEC&nbsp;<img src="../../../assets/images/check.svg"
                              alt="logo-icon" style="max-width:25%;" /></span></p>
                        <p v-if="status === 'SUCCEEDED'"><span
                            class="section_label">STATUT........................................... </span><span
                            class="section_content_other1">SUCCÈS&nbsp;<img src="../../../assets/images/check.svg"
                              alt="logo-icon" style="max-width:25%;" /></span></p>
                        <p v-if="status === 'PROCESSING' || status === 'PENDING'"><span
                            class="section_label">STATUT........................................... </span><span
                            class="section_content_other1">EN COURS&nbsp;<img src="../../../assets/images/check.svg"
                              alt="logo-icon" style="max-width:25%;" /></span></p>
                      </div>
                      <div id="body_third_section">
                        <p><span class="section_label">MERCI POUR LA CONFIANCE !</span>&nbsp;&nbsp;<span
                            class="section_content"><img src="../../../assets/images/imoji.svg" alt="logo-icon"
                              style="max-width:25%;" /></span></p>
                      </div>
                      <div id="arrow-bottom-section">
                        <span id="arrow-bottom-left" class="section_content"><img
                            src="../../../assets/images/arrowbottomleft.svg" alt="logo-icon"
                            style="min-width:3%;" /></span>
                        <span id="arrow-bottom-right" class="section_content"><img
                            src="../../../assets/images/arrowbottomright.svg" alt="logo-icon"
                            style="min-width:3%;" /></span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import router from '@/router';
import { useRoute } from 'vue-router'
import axios from 'axios';
import { ref, reactive, inject, onMounted, onBeforeUnmount, nextTick, computed } from 'vue';
import html2pdf from "html2pdf.js";
import * as yup from 'yup';
import "intl-tel-input/build/css/intlTelInput.css";

import intlTelInput from 'intl-tel-input';
import { Operator } from "@/utils/Model";

import mtn from "../../../assets/images/operator/mtn1.png"
import wave from "../../../assets/images/operator/wave.png"
import orange from "../../../assets/images/operator/om1.png"
import moov from "../../../assets/images/operator/moov1.png"

import { validate_phone_number, formatDateFr } from "../../../utils/function";
const backApi = inject('back');

const beRedirect = inject('beRedirect');
const errors = ref('');
const errorId = ref('');
const success = ref('');
const name = ref('');
const errorsBis = { 'otp': "", 'amount': 0 };
const phone = ref("");
const operators = ref(new Array<Operator>());
const operatorsLoading = ref(true);
let operatorsTemp = new Array<Operator>();

let environment = process.env.VUE_APP_TEST
const selectedOperator = ref('');
if (process.env.VUE_APP_TEST == 'DEMO') {
  selectedOperator.value = 'WAVE';
}

let contrycode = '';
let contryIndicatif = ''
const step1 = ref(1);
const step2 = ref(0);
const step3 = ref(0);
const OTP_OPERATOR = ref(process.env.VUE_APP_OTP_OPERATOR);
const MTN_OPERATOR = ref(process.env.VUE_APP_MTN);
const MOOV_OPERATOR = ref(process.env.VUE_APP_MOOV);
const WAVE_OPERATOR = ref(process.env.VUE_APP_WAVE);
let checkoutId = "";
let publicToken: string | null = '';
const amount = ref(0);
const amountInit = ref(0);
const status = ref(null);
let countRetry = 0;
let linkGenerated = false;
let verify_transact;
let sampleInterval;
const btnLoad = ref(true);
let startingMinutes = ref(5);
let startingSeconds = ref(0);
const mins = ref(startingMinutes);
const secs = ref(startingSeconds);
let paymentUrl;
const wavePaymentUrl = ref('');
const showWavePaymentButton = ref(false);

const isMobile = ref(false);
const appOpening = ref(false);
const showGuichet = ref(false); 
const deepLink = ref('');

const DEEP_LINK_SCHEME = 'izyapp://payment/encaissement/';
const APP_OPEN_TIMEOUT = 2500;

let autoRedirectTimer: ReturnType<typeof setTimeout> | null = null;

let itiInitialized = false;

const detectMobile = (): boolean => {
  if (typeof window === 'undefined') return false;
  const userAgentMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
  const smallScreen = window.innerWidth <= 767;
  return userAgentMobile || smallScreen;
};

const displayGuichet = () => {
  appOpening.value = false;
  showGuichet.value = true;
  nextTick(() => initPhoneInput());
};

const startAppOpenFlow = () => {
  if (!publicToken) {
    displayGuichet();
    return;
  }

  appOpening.value = true;
  showGuichet.value = false;
  deepLink.value = DEEP_LINK_SCHEME + publicToken;

  try {
    window.location.href = deepLink.value;
  } catch (e) {
    console.warn("Redirection automatique bloquée par le navigateur.", e);
  }

  autoRedirectTimer = setTimeout(() => {
    if (!document.hidden) {
      displayGuichet();
    }
  }, APP_OPEN_TIMEOUT);
};

const initPhoneInput = () => {
  const inputc = document.querySelector("#phone") as HTMLInputElement | null;

  if (!inputc) {
    console.warn("Champ #phone introuvable. Report de l'initialisation d'intlTelInput.");
    return;
  }

  if (itiInitialized) return;
  itiInitialized = true;

  iti = intlTelInput(inputc, {
    onlyCountries: ["ci", "sn"],
    initialCountry: "auto",
    geoIpLookup: function (callback) {
      fetch("https://ipapi.co/json")
        .then(function (res) { return res.json(); })
        .then(function (data) { callback(data.country_code); })
        .catch(function () { callback("ci"); });
    }
  });

  initOperator('', inputc);

  iti.promise?.then(() => initOperator('', inputc));

  inputc.addEventListener("countrychange", function () {
    contryChange(iti.getSelectedCountryData());
  });
};

const handleVisibilityChange = () => {
  if (document.hidden && autoRedirectTimer) {
    clearTimeout(autoRedirectTimer);
    autoRedirectTimer = null;
  }
};
let iti;
const schema = yup.object({
  otp: yup.string(),
  amount: yup.number().required('Le montant est requis'),
});

const formValues = reactive({
  otp: "",
  amount: 0,
});

const isStep1Valid = computed(() => {
  return !!phone.value && phone.value.length > 0 && !!selectedOperator.value;
});

function operatorImg(operator) {
  let img;
  switch (operator) {
    case 'MTN':
      img = mtn;
      break;
    case 'WAVE':
      img = wave;
      break;
    case 'ORANGE':
      img = orange;
      break;
    case 'MOOV':
      img = moov;
      break;
    default:
      img = '';
      break;
  }
  return img;
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

function handlePhone(myvalue, tag) {
  if (!iti) return;
  const contry = iti.getSelectedCountryData()?.iso2;
  if (!contry) return;
  let phone_length = 0;
  switch (contry) {
    case 'ci':
      phone_length = process.env.VUE_APP_CI_PHONE_LENTGH;
      break;
    case 'sn':
      phone_length = process.env.VUE_APP_SN_PHONE_LENTGH;
      break;
    default:
      alert("Sélectionnez un pays");
  }
  validate_phone_number(myvalue, tag, phone_length)
}

function handleOperatorChange(operator) {
  selectedOperator.value = operator;
}

const filterOperatorsByCountry = (iso2?: string) => {
  const code = (iso2 || 'ci').toLowerCase();
  contrycode = code;
  operators.value = operatorsTemp.filter(
    (op) => (op.countryCode || '').toLowerCase() === code
  );
};

function contryChange(countryObject) {
  contryIndicatif = countryObject.dialCode;
  filterOperatorsByCountry(countryObject.iso2);
}

function initOperator(myValue?, tag?) {
  if (!iti) return; // ⚠️ Sécurité
  filterOperatorsByCountry(iti.getSelectedCountryData()?.iso2);
}

const next = () => {
  if (checkField()) {
    step1.value = 0;
    step2.value = 1;
    if (selectedOperator.value !== OTP_OPERATOR.value) {
      initTransaction();
      sampleInterval = setInterval(() => {
        if (secs.value > 0) {
          secs.value = secs.value - 1;
        }
        if (secs.value === 0) {

          if (mins.value < 0) {
            checkPublicTransactionStatus();
            clearInterval(verify_transact);
            clearInterval(sampleInterval);
            btnLoad.value = true;
            step3.value = 1;
            step2.value = 0;
            step1.value = 0;

          } else {
            mins.value = mins.value - 1;
            secs.value = 59;
            if ((mins.value - 1) === -1) {
              checkPublicTransactionStatus();
              clearInterval(verify_transact);
              clearInterval(sampleInterval);
              btnLoad.value = true;
              step3.value = 1;
              step2.value = 0;
              step1.value = 0;

            }

          }
        }
      }, 1000);

      return () => {
        clearInterval(sampleInterval);

      };
    }
  }
}

const goback = () => {
  step1.value = 1;
  step2.value = 0;
  step3.value = 0;
  showWavePaymentButton.value = false;
  wavePaymentUrl.value = '';
  router.go(0)
}

const openWavePayment = () => {
  if (wavePaymentUrl.value) {
    window.location.href = wavePaymentUrl.value;
  }
}
const checkField = () => {
  let result = true;
  if (selectedOperator.value == "") {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez sélectionner un opérateur.";
    result = false;
  }
  if (amount.value <= 0) {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez entrer un montant valide.";
    result = false;
  }
  if (phone.value == "" || (phone.value.length < process.env.VUE_APP_CI_PHONE_LENTGH && contrycode == "ci") || (phone.value.length < process.env.VUE_APP_SN_PHONE_LENTGH && contrycode == "sn")) {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez entrer un numéro valide.";
    result = false;
  }

  return result;
}

const checkFieldForm = () => {
  let result = true;
  if (selectedOperator.value == "") {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez sélectionner un opérateur.";
    result = false;
  }
  if (amount.value <= 0) {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez entrer un montant valide.";
    result = false;
  }
  if (phone.value == "" || (phone.value.length < process.env.VUE_APP_CI_PHONE_LENTGH && contrycode == "ci") || (phone.value.length < process.env.VUE_APP_SN_PHONE_LENTGH && contrycode == "sn")) {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez entrer un numéro valide.";
    result = false;
  }
  if (formValues.otp == "" && OTP_OPERATOR.value == selectedOperator.value) {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez entrer un code otp valide.";
    result = false;
  }
  return result;
}

const initTransaction = async () => {


  if (checkFieldForm()) {
    btnLoad.value = false;
    try {

      schema.validateSync(formValues);

      axios.post(backApi + '/public/transactions/init', {
        operator: selectedOperator.value,
        publicToken: publicToken,
        amount: amount.value,
        mobile: phone.value,
        operationType: parseInt(process.env.VUE_APP_PAYIN_OPTTYPE),
        countryCode: contrycode,
        otp: formValues.otp,
        successUrl: window.location.origin + "/transaction/success/" + publicToken,
        errorUrl: window.location.origin + "/transaction/failed/" + publicToken
      }, {
        headers: {
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        if (response.status == 201) {
          checkoutId = response.data.checkoutId;

          if (selectedOperator.value == WAVE_OPERATOR.value || selectedOperator.value == OTP_OPERATOR.value || selectedOperator.value == MTN_OPERATOR.value || selectedOperator.value == MOOV_OPERATOR.value) {
            verify_transact = setInterval(checkPublicTransactionStatus, 10000);
          }

        }
      }).catch((error) => {
        btnLoad.value = true;
        if (error.response) {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      });


    } catch (error) {
      console.error(error);
      if (error.response) {
        errorId.value = error.response.data.errorId;
        errors.value = error.response.data.message;
      }
      btnLoad.value = true;

    }
  }

};


const showPublicTransaction = (token) => {

  axios.get(backApi + '/public/transactions/' + token, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then((response) => {
      if (response.status == 200) {
        amountInit.value = response.data.amount;
        amount.value = response.data.amount;
        status.value = response.data.paymentStatus;
        checkoutId = response.data.checkoutId;

      }

    }).catch((error) => {
      if (error.response) {
        errors.value = error.response.data;
        router.push('/');
      }
    });
}

const checkPublicTransactionStatus = () => {

  axios.get(backApi + '/public/transactions/' + publicToken, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then((response) => {
      if (response.status == 200) {

        status.value = response.data.paymentStatus;
        countRetry += 1;
        if (selectedOperator.value == OTP_OPERATOR.value && (countRetry == 3 || status.value == "SUCCEEDED" || status.value == "FAILED")) {
          clearInterval(verify_transact);
          btnLoad.value = true;
          step3.value = 1;
          step2.value = 0;
          step1.value = 0;
        }
        if ((selectedOperator.value == MTN_OPERATOR.value || selectedOperator.value == MOOV_OPERATOR.value) && (status.value == "SUCCEEDED" || status.value == "FAILED")) {

          clearInterval(verify_transact);
          clearInterval(sampleInterval);
          btnLoad.value = true;
          step3.value = 1;
          step2.value = 0;
          step1.value = 0;

        }
        if (selectedOperator.value == WAVE_OPERATOR.value) {
          if (status.value == "SUCCEEDED" || status.value == "FAILED") {
            clearInterval(verify_transact);
            btnLoad.value = true;
            step3.value = 1;
            step2.value = 0;
            step1.value = 0;
          }
          if (linkGenerated == false) {
            if (response.data.paymentUrl !== "") {
              linkGenerated = true;
              paymentUrl = response.data.paymentUrl;
              const popup = window.open(paymentUrl, '_blank');
              if (!popup || popup.closed || typeof popup.closed === 'undefined') {
                wavePaymentUrl.value = paymentUrl;
                showWavePaymentButton.value = true;
                btnLoad.value = true;
              }
            }
          }

        }
        console.log(response.data);

      }

    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        errorId.value = error.response.data.errorId;
        errors.value = error.response.data.message;
      }
    });
}

const getOperators = () => {

  operatorsLoading.value = true;

  axios.get(backApi + '/public/operators/', {
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then((response) => {
      operatorsTemp = response.data;
      console.log(response.data);

      if (iti && document.querySelector('#phone')) {
        initOperator('', document.querySelector('#phone'));
      }
      operatorsLoading.value = false;

    }).catch((error) => {
      operatorsLoading.value = false;
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')

        }

      }
    });
}

const PDFReceipt = ref<HTMLElement | null>(null);

const download_receipt = () => {
  const element = PDFReceipt.value;
  if (element) element.classList.remove("d-none");

  showPublicTransaction(publicToken)

  setTimeout(() => {
    showPublicTransaction(publicToken)

    const receiptEl = document.getElementById("receipt");
    if (!receiptEl) return;

    receiptEl.style.display = 'block';
    receiptEl.style.border = '1px solid #706F6F';

    const opt = {
      margin: [0, 0, 0, 0],
      filename: "receipt_" + publicToken + ".pdf",
      jsPDF: { unit: 'mm', format: 'a5', orientation: 'portrait', putOnlyUsedFonts: true, floatPrecision: "smart" },
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
    }

    html2pdf().set(opt).from(receiptEl).toPdf().save()
  }, 3000);
}


onMounted(() => {
  linkGenerated = false;
  showWavePaymentButton.value = false;
  wavePaymentUrl.value = '';
  operatorsLoading.value = true;
  const route = useRoute();
  publicToken = route.params.token;
  checkoutId = "";
  isMobile.value = detectMobile();

  if (isMobile.value && beRedirect === 'true') {
    console.log('fhfhfhfhhffhfhhfffffff==',beRedirect)
    document.addEventListener('visibilitychange', handleVisibilityChange);
    startAppOpenFlow();
  } else {
    console.log('FALSE FALSE==',beRedirect)
    displayGuichet();
  }
  getOperators();
  showPublicTransaction(publicToken);
});

onBeforeUnmount(() => {
  if (autoRedirectTimer) clearTimeout(autoRedirectTimer);
  document.removeEventListener('visibilitychange', handleVisibilityChange);
});
</script>

<style scoped>
.app-opening-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  z-index: 9999;
}

.app-opening-overlay .payment-waiting {
  padding: 0;
}

.payment-waiting {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.25rem 0 0.5rem;
}

.payment-waiting__ring {
  width: 25px;
  height: 25px;
  border: 3px solid rgba(235, 147, 85, 0.18);
  border-top-color: #EB9355;
  border-right-color: #EB9355;
  border-radius: 50%;
  animation: payment-waiting-spin 0.9s cubic-bezier(0.5, 0.1, 0.4, 0.9) infinite;
  margin-bottom: 1rem;
}

.payment-waiting__text {
  margin: 0 0 0.5rem;
  color: #4a4a4a;
  font-size: 0.95rem;
  font-weight: 500;
  letter-spacing: 0.01em;
  text-align: center;
}

.payment-waiting__dots {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 10px;
}

.payment-waiting__dots span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #EB9355;
  animation: payment-waiting-bounce 1.2s ease-in-out infinite;
}

.payment-waiting__dots span:nth-child(1) {
  animation-delay: 0s;
}

.payment-waiting__dots span:nth-child(2) {
  animation-delay: 0.15s;
}

.payment-waiting__dots span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes payment-waiting-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes payment-waiting-bounce {
  0%,
  80%,
  100% {
    transform: translateY(0) scale(0.85);
    opacity: 0.45;
  }

  40% {
    transform: translateY(-6px) scale(1);
    opacity: 1;
  }
}

.izypay-logo {
  height: 28px;
  width: auto;
}

.field {
  height: 30px;
}

.selectfield {
  height: 45px;
}

.operators-loading {
  padding: 10px 0 4px;
}

.operators-loading__text {
  margin: 8px 0 0;
  color: #4a4a4a;
  font-size: 0.9rem;
}

.btn-payer:disabled,
.btn-payer[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.PDFReceipt.d-none {
  display: block !important;
  visibility: hidden;
}

#receipt {
  margin-top: 5px;
  border: 1px solid #706F6F;
  display: flex;
  flex-direction: column;
  width: 148mm;
  width: 100%;
}

#header_receipt {
  margin-top: -1%;
  background-color: #871728;
}

#logo_text {
  font-family: gruppo;
}

#header_text {
  font-size: 70%;
  float: inline-end;
  margin-top: 3%;
}

#arrow-top-left {
  margin-left: 12%
}

#arrow-top-right {
  margin-left: 70%
}

#arrow-bottom-left {
  margin-left: 12%
}

#arrow-bottom-right {
  margin-left: 70%
}

#body_receipt {
  display: flex;
  flex-direction: column;
  padding-top: 15%;
  width: 100%;
}

#body_first_section {
  margin-left: 15%;
  margin-right: 15%;
  border: 1px solid #706F6F;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}

#body_second_section {
  margin-top: 5%;
  margin-left: 15%;
  margin-right: 15%;
  border: 1px solid #706F6F;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}

#body_third_section {
  margin-top: 5%;
  margin-left: 15%;
  margin-right: 15%;
  border: 1px solid #706F6F;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}

.section_label {
  font-size: 100%;
  font-weight: bold;
}

.section_content_other {
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  margin-left: 10%;
  padding: 5px 15px 5px 15px;
}

.section_content_other1 {
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}

@media (min-width: 768px) {
  .authentication-card {
    width: 52rem;
  }

}

:deep(.iti) {
  display: block;
  width: 100%;
}

:deep(.iti input.iti__tel-input) {
  width: 100%;
}

.operator-img, .operator-img_div {
  width: 50px !important;
  height: 50px !important;
}

.operators-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.operator-logo {
  cursor: pointer;
  transition: transform 0.2s, opacity 0.2s;
  flex-shrink: 0;
}

.operator-logo:hover {
  transform: scale(1.1);
  opacity: 0.8;
}

@media (max-width: 575.98px) {
  .form-group .field {
    width: 100%;
  }

  .operators-list {
    gap: 8px;
    padding: 0 10px;
  }

  .operator-logo {
    width: 40px !important;
    height: 40px !important;
    max-width: 40px !important;
    max-height: 40px !important;
  }
}

@media (max-width: 400px) {
  .authentication-card {
    width: 100% !important;
    max-width: 100%;
  }
  .operators-list {
    gap: 6px;
    padding: 0 5px;
  }

  .operator-logo {
    width: 35px !important;
    height: 35px !important;
    max-width: 35px !important;
    max-height: 35px !important;
  }
}

@media (max-width: 360px) {
  .authentication-card {
    width: 100% !important;
    max-width: 100%;
  }
  .operators-list {
    gap: 5px;
    padding: 0;
  }

  .operator-logo {
    width: 30px !important;
    height: 30px !important;
    max-width: 30px !important;
    max-height: 30px !important;
  }
}

@media (max-width: 767.98px) {
  .card-body {
    overflow-x: hidden;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .field {
    height: 42px;
  }

  :deep(.iti input.iti__tel-input) {
    height: 42px;
  }

  .btn-payer {
    height: auto !important;
    min-height: 48px;
  }
}
</style>